import { render, staticRenderFns } from "./DowntimeReports.vue?vue&type=template&id=b093b906"
import script from "./DowntimeReports.vue?vue&type=script&lang=js"
export * from "./DowntimeReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports